import styled from 'styled-components';
import { loaderAnimationStyles } from '@dealstack/frontend/shared/components/loaders/shared/loaderAnimation.styles';

export const FullLoaderAnimationStyles = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;

	svg {
		max-width: 500px;
		display: block;
		flex-shrink: 0;
	}

	${loaderAnimationStyles}
`;

/** Full screen overlay */
export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 30vh 30vw;
	background-color: white;
	cursor: wait;
	visibility: hidden;
	z-index: 999999;
`;
